import React, { useState, useEffect } from 'react';
import API from '../../api/axios';
import './Admin.css';

export default function AdminBroadcastPage() {
    const [subject, setSubject] = useState('');
    const [body, setBody] = useState('');
    const [sending, setSending] = useState(false);
    const [result, setResult] = useState(null);
    const [error, setError] = useState(null);
    const [history, setHistory] = useState([]);
    const [gender, setGender] = useState('');
    const [verified, setVerified] = useState('');

    const loadHistory = () => {
        API.get('/api/admin/broadcast-email/history')
            .then((res) => setHistory(res.data.broadcasts || []))
            .catch(() => {});
    };

    useEffect(() => {
        loadHistory();
    }, []);

    const handleSend = async () => {
        setError(null);
        setResult(null);
        if (!subject.trim() || !body.trim()) {
            setError('Subject and message are required.');
            return;
        }
        if (!window.confirm('Send this email to every subscribed user? This cannot be undone.')) {
            return;
        }
        try {
            setSending(true);
            // Convert plain-text line breaks to paragraphs for a basic HTML email.
            const bodyHtml = body
                .split('\n\n')
                .map((para) => `<p>${para.replace(/\n/g, '<br/>')}</p>`)
                .join('');
            const res = await API.post('/api/admin/broadcast-email', {
                subject,
                body: bodyHtml,
                gender: gender,
                verified: verified,
            });
            setResult(res.data);
            setSubject('');
            setBody('');
            loadHistory();
        } catch (err) {
            setError(err.response?.data?.message || 'Failed to send broadcast.');
        } finally {
            setSending(false);
        }
    };

    return (
        <div className="admin-page">
            <header className="admin-header">
                <h1>Broadcast Email</h1>
            </header>

            <div style={{ padding: '0 16px' }}>
                <p style={{ color: '#666', fontSize: 14, marginBottom: 16 }}>
                    Sends an announcement email to every verified, non-banned user
                    who has email notifications enabled in their settings.
                </p>

                {error && <div className="donate-error" style={{ margin: '0 0 16px' }}>{error}</div>}
                {result && (
                    <div style={{
                        background: '#eafaf1', color: '#27ae60', padding: 12,
                        borderRadius: 8, marginBottom: 16, fontSize: 14,
                    }}>
                        Broadcast started — sending to {result.recipient_count} recipients.
                    </div>
                )}

                <input
                    type="text"
                    placeholder="Subject"
                    value={subject}
                    onChange={(e) => setSubject(e.target.value)}
                    style={{
                        width: '100%', padding: 12, marginBottom: 12,
                        border: '1px solid #e5e5ea', borderRadius: 8, fontSize: 15,
                    }}
                />
                <textarea
                    placeholder="Write your message..."
                    value={body}
                    onChange={(e) => setBody(e.target.value)}
                    rows={10}
                    style={{
                        width: '100%', padding: 12, marginBottom: 12,
                        border: '1px solid #e5e5ea', borderRadius: 8, fontSize: 15,
                        fontFamily: 'inherit', resize: 'vertical',
                    }}
                />
                    <div style={{ display: 'flex', gap: 12, marginBottom: 12 }}>
               <select
                        value={gender}
                        onChange={(e) => setGender(e.target.value)}
                        style={{
                            flex: 1, padding: 12, border: '1px solid #e5e5ea',
                            borderRadius: 8, fontSize: 15, background: 'white',
                        }}
                    >
                        <option value="">All genders</option>
                        <option value="male">Male only</option>
                        <option value="female">Female only</option>
                    </select>
                    <select
                        value={verified}
                        onChange={(e) => setVerified(e.target.value)}
                        style={{
                            flex: 1, padding: 12, border: '1px solid #e5e5ea',
                            borderRadius: 8, fontSize: 15, background: 'white',
                        }}
                    >
                        <option value="">All (verified + unverified)</option>
                        <option value="verified">Verified only</option>
                        <option value="unverified">Unverified only</option>
                    </select>
                    </div>
                <button
                    onClick={handleSend}
                    disabled={sending}
                    style={{
                        width: '100%', padding: 14, border: 'none', borderRadius: 10,
                        background: sending ? '#ccc' : '#C8102E', color: 'white',
                        fontWeight: 700, fontSize: 15, cursor: sending ? 'not-allowed' : 'pointer',
                    }}
                >
                    {sending ? 'Starting broadcast...' : 'Send to all subscribers'}
                </button>
            </div>

            <h2 style={{ padding: '24px 16px 8px', fontSize: 16 }}>Recent broadcasts</h2>
            <div className="donations-list">
                {history.length === 0 && <p className="empty">No broadcasts sent yet.</p>}
                {history.map((b) => (
                    <div key={b.id} className="donation-card">
                        <div className="donation-main">
                            <span style={{ fontWeight: 700 }}>{b.subject}</span>
                            <span className={`badge status-${b.status === 'completed' ? 'successful' : 'pending'}`}>
                                {b.status}
                            </span>
                        </div>
                                               <p className="donation-donor">{b.body_preview}</p>
                        <div className="donation-meta">
                            <span>
                                {b.recipient_count} recipients
                                {b.gender_filter ? ` · ${b.gender_filter}` : ''}
                                {b.verified_filter ? ` · ${b.verified_filter}` : ''}
                            </span>
                            <span>{new Date(b.created_at).toLocaleString()}</span>
                        </div>
                    </div>
                ))}
            </div>
        </div>
    );
}